// extracted by mini-css-extract-plugin
module.exports = {"row":"_10X87"};